import { METRICS_TABS } from 'lib'
import axiosInstance from './axiosInstance'

export const getMetrics = (tab = METRICS_TABS.Entire) => {
  return axiosInstance.get(`/report/get-metrics?tab=${tab}`)
}

export const getMetricsTaskDue = () => {
  return axiosInstance.get('/report/get-metrics-task-due')
}

export const getMetricsNoActivity = () => {
  return axiosInstance.get('/report/get-metrics-no-activity')
}

export const getTeamTaskReport = () => {
  return axiosInstance.get('/report/get-team-task-report')
}

export const getTeamTaskReportIndividual = (pmId, page = 1, limit = 20, search = '', orderByKey = 'dueDate', direction = 'desc') => {
  return axiosInstance.get(`/report/get-team-task-report/${pmId}?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}
